/* src/app/forms/produtos/mercadolivre/meli-item/meli-item.component.scss */
.meli-card {
  display: flex;
  flex-direction: column;
  position: relative;
  max-height: 500px;
  padding: 12px;
  background: var(--tem-surface, #fff);
  border: 1px solid var(--tem-border, #f0f0f0);
  border-radius: var(--tem-radius, 8px);
  transition: box-shadow 0.3s;
}
.meli-card:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.4);
}
.selected {
  border: #008000 solid;
}
.meli-card-header {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
}
.meli-card-heading {
  flex: 1;
  min-width: 0;
}
.meli-card-title {
  font-weight: 600;
  font-size: var(--tem-fs-lg, 16px);
  max-height: 60px;
  height: 40px;
  min-height: 40px;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.meli-card-subtitle {
  color: var(--tem-muted, rgba(0, 0, 0, 0.45));
  font-size: var(--tem-fs-sm, 12px);
}
.foto {
  align-self: center;
}
.dados {
  margin-left: 20px;
  flex-grow: 3;
}
.sumario {
  width: 100%;
}
.sumario .left {
  padding: 6px;
  float: left;
  width: 100%;
  font-size: 100%;
}
.sumario .right {
  padding: 6px;
  float: right;
  width: 50%;
  font-size: 10px;
}
.content {
  display: flex;
  padding: 12px;
  min-height: 140px;
  max-height: 140px;
}
.responsive {
  width: 100%;
  height: auto;
}
.meli-card-actions {
  margin-top: auto;
  padding-top: 8px;
}
.actions-buttons {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}
.actions-buttons button {
  width: 100%;
}
/*# sourceMappingURL=meli-item.component.css.map */
